import { mapGetters } from 'vuex';

export default {
    name: 'mvtListLinks',
    props: {
        title: {
            type: String,
            default: ''
        },
        subTitle: {
            type: String,
            default: ''
        },
        links: {
            type: Array,
            required: true,
            default: () => []
        },
        showListingCount: {
            type: Boolean,
            required: false,
            default: false
        },
        nameForUrl: {
            type: String,
            required: false,
            default: 'nameForUrl'
        },
        displaySuffix: {
            type: String,
            required: false,
            default: ''
        },
        marketTrends: {
            type: String,
            default: ''
        },
        initialFilter: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        linksWithUrls(){
            if(this.initialFilter && this.initialFilter.length && !this.showAll) {
                return this.links.filter(link => (this.initialFilter.includes(link.nameForUrl)))
            }
            return this.links.filter(link => link.nameForUrl);
        },
        showHideText() {
            if(this.marketTrends) {
                return this.showAll && `Show Less ${this.marketTrends}` || `Show All ${this.marketTrends}`;
            }
            return this.showAll && this.molang('common.showLess') || this.molang('common.showAll');
        },
        isSpecificPageType(){
            return ['vsitemap_agentstates','vsitemap_states','vmarket-trends','vschools_base'].indexOf(this.glb.pageType) !== -1;
        }
    },
    data(){
        return {
            showAll: false
        }
    },
    methods: {
        toggle(e){
            this.showAll = !this.showAll;
            if(!this.showAll){
                setTimeout(function(){
                    e.target && e.target.scrollIntoView()
                },1);
            }
        }
    }
};